import { Flex } from 'foundations-components/components/Flex';
import { ChangeProviderButton } from 'calling-integration-sdk-support/viewport/components/ChangeProviderButton';
import openCallingWidget from 'calling-global-api/methods/openCallingWidget';
import { logCallingError, logError } from 'calling-error-reporting/report/error';
import { useCallback, useMemo } from 'react';
import { OPEN_PROVIDER_MENU } from 'calling-integration-cross-tab/types/BroadcastEvents';
import { createBroadcastMessage } from 'calling-integration-cross-tab/messages/createBroadcastMessages';
import { sendCrossTabMessage } from 'calling-cross-tab-library/external/sendCrossTabMessage';
import { CALLING_EXTENSIONS_CLICK_TO_CALL_MIGRATION } from 'calling-internal-common/constants/CallingGates';
import { jsx as _jsx } from "react/jsx-runtime";
const ChangeProviderButtonWrapper = ({
  providerName,
  location,
  gates
}) => {
  const isUngatedForThirdPartyClickToCallMigration = useMemo(() => {
    return gates.includes(CALLING_EXTENSIONS_CLICK_TO_CALL_MIGRATION);
  }, [gates]);
  const handleToggleProviderMenu = useCallback(showProviderMenu => {
    if (isUngatedForThirdPartyClickToCallMigration) {
      sendCrossTabMessage(createBroadcastMessage({
        type: OPEN_PROVIDER_MENU,
        payload: {
          showProviderMenu
        }
      })).catch(error => {
        logCallingError({
          error,
          tags: {
            requestName: 'sendCrossTabMessage - open provider menu'
          }
        });
      });
    } else {
      openCallingWidget({
        showProviderMenu
      }).catch(error => {
        logError(error);
      });
    }
  }, [isUngatedForThirdPartyClickToCallMigration]);
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "space-between",
    paddingInlineStart: "100",
    paddingInlineEnd: "400",
    alignItems: "center",
    children: /*#__PURE__*/_jsx(ChangeProviderButton, {
      toggleProviderMenu: handleToggleProviderMenu,
      size: "medium",
      location: location,
      providerName: providerName
    })
  });
};
export default ChangeProviderButtonWrapper;